import { legacyImageForProductName } from './productLegacyImage.js'

/** URL-safe filename stem for `public/products/{slug}.png`. */
export function productImageSlug(name: string): string {
  const slug = name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 96)
  return slug || 'product'
}

/** Path served from `public/products/` — prefers legacy filenames that match deployed box art. */
export function productImagePath(name: string): string {
  const legacy = legacyImageForProductName(name)
  if (legacy) return `/products/${legacy}`
  return `/products/${productImageSlug(name)}.png`
}

/** Short label rendered on generated box art. */
export function productBoxTitle(name: string): string {
  let t = name.trim()
  if (/^steam shared access:\s*/i.test(t)) {
    return t.replace(/^steam shared access:\s*/i, 'STEAM · ').toUpperCase()
  }
  t = t
    .replace(/\s+shared access(\s+\([^)]+\))?/gi, ' LIFETIME$1')
    .replace(/\s+fa\b/gi, ' FA')
    .replace(/\s*\(\s*/g, ' (')
  return t.toUpperCase()
}
